export default "__VITE_ASSET__Cpq3QK6d__"